module.exports = __webpack_public_path__ + "img/akusherstij-stacioner4.4c83a0e8.jpg";